import store from 'redux/store';
import { values, find } from 'underscore';

/* @ngInject */
export function getCourseByCatalogId(catalogId: string) {
  if (!catalogId) {
    return null;
  }

  return store.getState()?.models?.courses?.[catalogId];
}

/* @ngInject */
export function getCourseById(id: number) {
  if (!id) {
    return null;
  }

  const stateCourses = store.getState().models.courses ?? [];
  return find(values(stateCourses), { id: +id });
}
